module.exports = __webpack_public_path__ + "static/media/noun_pc web_453711.ff62b22f.svg";